import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import moment from 'moment';
import queryString from 'query-string';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import BobModal from '../../../components/BobModal';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import ExportDataTimestamp from '../../../components/RuleExceptionsTable/ExportDataTimestamp';

import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './AddNewEntityModal.module.css';


const DefaultAllowedTimeIntervals = [
    { id: 1, name: '1' },
    { id: 5, name: '5' },
    { id: 10, name: '10' },
    { id: 15, name: '15' },
    { id: 30, name: '30' }, 
    { id: 60, name: '60' }
];

const ExportDataModal = ({
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    entity,
    exportGraphData,
    exportTableData,
    history,
    isExportRawData,
    selectedRuleSensors,
    selectedRule,
    setExportModalOpen,
    tabView,
    tableProps,
    ...props
}) => {

    const [selectedTime, setSelectedTime] = useState('Last 24 Hours');
    const [startTimestamp, setStartTimestamp] = useState(moment().subtract(7,'d').local().startOf('day'));
    const [endTimestamp, setEndTimestamp] = useState(moment().local().startOf('day'));
    const [selectedInterval, setSelectedInterval] = useState(15);
    const [allowedIntervals, setAllowedIntervals] =  useState(DefaultAllowedTimeIntervals);
    const [selectedDateDiff, setSelectedDateDiff] = useState(14);
    // const [selectedAction, setSelectedAction] = useState('Raw');

    const Intervals = [ 
        { id: 'Last 24 Hours',                    name: 'Last 24 Hours'},
        { id: '7 Days',                           name: '7 Days'},
        { id: 'Current Month',                    name: 'Current Month'},
        { id: 'Last Month',                       name: 'Last Month'},
        { id: '31 Days',                          name: '31 Days'},
        // { id: '60 Days (Raw Data Only)',          name: '60 Days (Raw Data Only)'},
        // { id: '90 Days (Raw Data Only)',          name: '90 Days (Raw Data Only)'},
        // { id: 'Current Quarter (Raw Data Only)',  name: 'Current Quarter (Raw Data Only)'},
        // { id: 'Previous Quarter (Raw Data Only)', name: 'Previous Quarter (Raw Data Only)'},
        // { id: '6 Months (Remove for now)',        name: '6 Months (Remove for now)'},
        { id: 'Custom',                           name: 'Custom'},
    ];

    useEffect(() => {
        if (!dashboardIsCurrentTimeStamp) {
            setStartTimestamp(dashboardStartTimeStamp);
            setEndTimestamp(dashboardEndTimeStamp);
        }
        setSelectedInterval(desiredInterval);
    }, []);
    
    useEffect(() => {
        switch (true) {
            case (selectedDateDiff > 185):
                setAllowedIntervals([    
                    { id: 15, name: '15' },
                    { id: 30, name: '30' }, 
                    { id: 60, name: '60' },
                    { id: 1440, name: '1 Day' }
                ]);
                if (selectedInterval < 15 ) {
                    setSelectedInterval(15);
                }
                break;
            case (selectedDateDiff > 31):
                setAllowedIntervals([
                    { id: 10, name: '10' },
                    { id: 15, name: '15' },
                    { id: 30, name: '30' }, 
                    { id: 60, name: '60' },
                    { id: 1440, name: '1 Day' }
                ]);
                if (selectedInterval < 10 ) {
                    setSelectedInterval(10);
                }
                break;
            case (selectedDateDiff > 14):
                setAllowedIntervals([
                    { id: 5, name: '5' },
                    { id: 10, name: '10' },
                    { id: 15, name: '15' },
                    { id: 30, name: '30' }, 
                    { id: 60, name: '60' },
                    { id: 1440, name: '1 Day' }
                ]);
                if (selectedInterval < 5 ) {
                    setSelectedInterval(5);
                }
                break;
            default:
                setAllowedIntervals(DefaultAllowedTimeIntervals);
        }
    },[selectedDateDiff]);

    const handleIntervalChange = async event => {
        const { value } = event.target;
        setSelectedInterval(value);
        switch (value) {
            case 1:
                if (moment(endTimestamp).local().diff(moment(startTimestamp).local(), 'h') > 1)
                {
                    setStartTimestamp(moment(endTimestamp).local().subtract(1, 'h'));
                }
                break;
            case 5:
            case 10:
                break;
            default:
        }
    };

    const handleTimeChange = async event => {
        const { value } = event.target;
        setSelectedTime(value);
        switch (value) {
            case 'Last 24 Hours':
                setAllowedIntervals(DefaultAllowedTimeIntervals);
                break;
            case 'Current Month':
            case 'Last Month':
            case '31 Days':
                setAllowedIntervals([
                    { id: 5, name: '5' },
                    { id: 10, name: '10' },
                    { id: 15, name: '15' },
                    { id: 30, name: '30' }, 
                    { id: 60, name: '60' },
                    { id: 1440, name: '1 Day' }
                ]);
                if (selectedInterval < 5) {
                    setSelectedInterval(5);
                }
                break;
            case '7 Days':
            case 'Custom':
                setAllowedIntervals([
                    { id: 1, name: '1' },
                    { id: 5, name: '5' },
                    { id: 10, name: '10' },
                    { id: 15, name: '15' },
                    { id: 30, name: '30' }, 
                    { id: 60, name: '60' },
                    { id: 1440, name: '1 Day' }
                ]);
                break;
            default:
                setAllowedIntervals(DefaultAllowedTimeIntervals);
        }
    };

    const handleSubmit = async => {
        const queryValues = queryString.parse(history.location.search);

        let startDate;
        let endDate = moment().local().endOf('day');

        switch (selectedTime) {
            case 'Custom':
                startDate = startTimestamp;
                endDate = endTimestamp;
                break;
            case 'Last 24 Hours':
                endDate = moment().local();
                startDate = moment(endDate).subtract(24,'h').local();
                break;
            case '7 Days':
                startDate = moment().subtract(6,'d').local().startOf('day');
                break;
            case '31 Days':
                startDate = moment().subtract(31,'d').local().startOf('day');
                break;
            case 'Current Month':
                startDate = moment().startOf('month');
                break;
            case 'Last Month':
                startDate = moment().subtract(1, 'months').startOf('month');
                endDate = moment().subtract(1, 'months').endOf('month');
                break;
            default:

        }

        let payload = { 
            ...queryValues,
            startDate,
            endDate
        };

        // This Export is only for Sensor Grid and Score Grid
        // This Export is only for Sensor Grid and Score Grid
        if (isExportRawData) {
            const zone = moment.tz.guess();
            const tzOffset = moment.tz.zone(zone).utcOffset(moment(endDate)) * -1;
            if (queryValues.system) {
                // Dashboard System page 
                exportGraphData(tabView, selectedRuleSensors, payload, { SystemId: queryValues.system, timediff: tzOffset, RuleId: selectedRule.ruleId, desiredInterval: 60 });
            } else {
                // Dashboard Equipment page
                const equipmentId = entity ? entity.id : queryValues.equipment; 
                exportGraphData(tabView, selectedRuleSensors, payload, { EquipmentId: equipmentId, timediff: tzOffset, RuleId: selectedRule.ruleId });
            }
        } else {
            exportTableData(tabView, payload, tableProps);
        }
        
        setExportModalOpen(false);
    };
    
    return (
        <BobModal
            title={'Export Data'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setExportModalOpen(false)}
            hasDatePicker={ selectedTime === 'Custom' }
        >
            <div className={classes.ModalBody}>
                <div className={classes.ExportSelectContainer}>
                    <div className={classes.ExportTimeSelect}>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="time"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Time
                            </InputLabel>
                            <Select
                                value={selectedTime}
                                onChange={handleTimeChange}
                                className={classes.select}
                                inputProps={{
                                    name: 'time',
                                    id:   'time'
                                }}
                            >
                                {
                                    Intervals.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>

                    </div>
                    <div className={classes.ExportIntervalSelect}>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="interval"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Desired Interval
                            </InputLabel>
                            <Select
                                value={selectedInterval}
                                onChange={handleIntervalChange}
                                className={classes.select}
                                inputProps={{
                                    name: 'interval',
                                    id:   'interval'
                                }}
                            >
                                {
                                    allowedIntervals.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.CustomDateSelect}>
                        {
                            selectedTime === 'Custom' ? 
                                <ExportDataTimestamp
                                    className={classes.TimestampOverride}
                                    desiredInterval={selectedInterval}
                                    maxDate={moment().local()}
                                    disableIntervalSelector={false}
                                    startTimestamp={startTimestamp}
                                    endTimestamp={endTimestamp}
                                    setStartTimestamp={setStartTimestamp}
                                    setEndTimestamp={setEndTimestamp}
                                    selectedDateDiff={selectedDateDiff}
                                    setSelectedDateDiff={setSelectedDateDiff}
                                /> 
                                : null
                        }
                    </div>
                    <div className={classes.ActionButtons}>
                        <div className={selectedTime === 'Custom' ? classes.ButtonContainerWithTimestamp : classes.ButtonContainer}>
                            <BobCancelButton
                                className={classes.CancelButton}
                                onClick={() => setExportModalOpen(false)}
                                label={'Cancel'}
                            />
                            <BobConfirmButton
                                className={classes.Buttons}
                                disabled={!selectedTime ? true : false}
                                onClick={handleSubmit}
                                label={'Export'}
                                iconSize={15}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => {
    return {
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExportDataModal));
